// extracted by mini-css-extract-plugin
export default {"taxTableOuter":"tax_taxTableOuter__vgh3b","submitBtn":"tax_submitBtn__lBzm1"};